import { RootPaths } from "../../App/paths";

export const IN_HOME_PATH = "in-home";
export const IN_HOME_FULL_PATH = `${RootPaths.APP_V2_HOME}/${IN_HOME_PATH}`;

export const IN_HOME_BOOKED_VISITS_PATH = "myVisits";
export const IN_HOME_BOOKED_VISIT_HISTORY_PATH = "myVisits/history";
export const IN_HOME_BOOKED_VISIT_HISTORY_FULL_PATH = `${RootPaths.APP_V2_HOME}/${IN_HOME_BOOKED_VISIT_HISTORY_PATH}`;

export const IN_HOME_CASE_DETAILS_PATH = `${IN_HOME_BOOKED_VISIT_HISTORY_PATH}/case/:caseId`;

export const IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH = `${IN_HOME_BOOKED_VISIT_HISTORY_PATH}/case/:caseId/visit/:visitId/visit-occurrences`;

export const BOOKED_VISIT_DETAILS_PATH = "myVisits/case/:caseId/visit/:visitId";
export const BOOKED_VISIT_DETAILS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${BOOKED_VISIT_DETAILS_PATH}`;

export const BOOKED_VISIT_CONFIRM_DATE_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/confirm-date-select";
export const BOOKED_VISIT_CONFIRM_DATE_FINALIZE_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/confirm-date-finalize";
export const BOOKED_VISIT_CONFIRM_DATE_CONFIRMED_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/confirm-date-confirmed";

export const BOOKED_VISIT_PEND_MODAL_PATH = "myVisits/case/:caseId/visit/:visitId/pend";

export const BOOKED_VISIT_DROP_MODAL_PATH = "myVisits/case/:caseId/visit/:visitId/drop";
export const BOOKED_VISIT_DROP_CONFIRMED_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/drop-confirmed";

export const BOOKED_VISIT_LOG_DATE_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/log-date-select";
export const BOOKED_VISIT_LOG_START_TIME_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/log-start-time-select";
export const BOOKED_VISIT_LOG_END_TIME_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/log-end-time-select";
export const BOOKED_VISIT_LOG_FINALIZE_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/log-finalize";
export const BOOKED_VISIT_LOG_CONFIRMED_MODAL_PATH =
  "myVisits/case/:caseId/visit/:visitId/log-confirmed";
